<template>
  <div>
    <Loader v-model="loading" />
    <!-- <v-dialog v-model="confirm" persistent max-width="290">
      <v-card>
        <v-card-title> Confirmacion </v-card-title>
        <v-card-text>Desea eliminar el registro?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="danger" text @click="confirm = false"> Cancelar </v-btn>
          <v-btn color="primary" text @click="finalizarConfirm()"> Aceptar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

  <v-app-bar app color="primary" dark class="cocina-header">
    <v-spacer></v-spacer>

    <v-toolbar-title class="titulo-cocina">
      Órdenes de Cocina
    </v-toolbar-title>

    <v-spacer></v-spacer>
  </v-app-bar>

  <v-main>
    <v-container fluid class="pa-0">
      <v-row class="ordenes-row">

        <v-col
          md="3"
          v-for="(orden, index) in ordenes"
          :key="orden.intPOSEnc"
          class="orden-col"
        >

          <v-card
            min-height="100px"
            @mousedown="seleccionarOrden(index)"
            @mouseup="deseleccionarOrden"
            @mouseleave="deseleccionarOrden"
            @touchstart="seleccionarOrden(index)"
            @touchend="deseleccionarOrden"
            @dblclick="finalizar(orden, index)"
            :color="ordenSeleccionada === index ? '#90CAF9' : orden.color"
            :class="{ 'orden-seleccionada': ordenSeleccionada === index }"
          >
            <h2>Espera: {{orden.lapsoTiempo}}</h2>
            <h1 COLOR="red">{{orden.strCancelacionDevolucion}}</h1>
            <v-card-title>
              <v-spacer></v-spacer>
              Orden {{orden.intOrden}} - {{orden.strCliente}} - {{orden.strTipoVenta}}
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text style="font-size: 15px;">
              <div style="color: #1C2833;" v-for="detalle in orden.posdet" :key="detalle.intPOSDet">
                ({{detalle.dblCantidad}}) - {{detalle.strNombre}}
                <div style="color: #566573;" v-for="detdet in detalle.posdetdet" :key="detdet.key">
                  -->  ({{detdet.cantidad}}) - {{detdet.strArticulo}}
                </div>
              </div>
            </v-card-text>
            <v-card-text>
              <v-card-subtitle>
                <v-spacer></v-spacer>
                  *****Notas *******
                <v-spacer></v-spacer>
                 {{orden.strNota}}
              </v-card-subtitle>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
  </div>
</template>

<script>
import Loader from "../components/Loader.vue";
import { Session, Toast, ErrorWeb,Data } from "../controllers/DataController.js";
import { POSEncFunctions } from "../controllers/POSController";
import moment from "moment";
import { toDateString } from "../js/utilities";
import { POSUserFunctions } from "../controllers/UserController.js";


function str_pad_left(string, pad, length) {
  return (new Array(length + 1).join(pad) + string).slice(-length);
}


export default {
  data() {
    return {
      loading: false,
      show: true,
      session: new Session(),
      dataFunctions: new Data(),
      ordenFunctions: new POSEncFunctions(),
      userFunctions: new POSUserFunctions(),
      ordenes:null,
      detalle:null,
      tiempos: [],
      ordenSeleccionada: null,
      time:null,
      terminales:[],
      intSucursal:this.$route.params.id,
      intEmpresa:this.$config.empresa,
      config_38_valor:this.$config.opciones.find((c) => c.id == 38).valor,
      config_38_activo:this.$config.opciones.find((c) => c.id == 38).activo,
      timerCronometro: null,
      timerRefresco: null,
      //confirm:false,
      // index:null,
      // id:{}
    };
  },
  components: {
    Loader,
  },
  watch: {
    loading(newValue) {
      this.$emit("loading", newValue);
    },
  },
  async mounted() {
    console.log(this.intSucursal)
    console.log( this.$route.params.id)
  },

  beforeDestroy() {
    if (this.timerCronometro) clearInterval(this.timerCronometro);
    if (this.timerRefresco) clearInterval(this.timerRefresco);
  },

  async created()
  {
    try {
      await this.getOrdenes(this.intSucursal);

      // Un solo intervalo para actualizar el cronómetro cada segundo
      this.timerCronometro = setInterval(() => {
        this.ordenes.forEach(orden => {
          orden.lapsoTiempo = this.getTime(orden);

          let segundosTotales = moment().diff(moment(orden.datFechaInicio), 'seconds');
          let hours = Math.floor(segundosTotales / 3600);
          segundosTotales = segundosTotales - hours * 3600;
          let minutes = Math.floor(segundosTotales / 60);
          if ((minutes + hours * 60) >= 5)  orden.color = "#ffffcc";
          if ((minutes + hours * 60) >= 10) orden.color = "#ff9999";
        });
      }, 1000);

      // Un solo intervalo para refrescar las órdenes cada 15 segundos
      this.timerRefresco = setInterval(() => {
        this.getOrdenes(this.intSucursal);
      }, 15000);

    } catch (e) {
      this.$toast.error(ErrorWeb(e), new Toast());
    }
  },
  methods: {
    toDateString: toDateString,
    getTime(orden) {
      // se obtinela fecha actual
      const now = new Date();
      // Convertimos la fecha de inicio de la orden a objeto Date
      const startDate = new Date(orden.fechaInicioMoment);

      // Calculamos la diferencia en milisegundos
      let diff = now - startDate;
      // Convertimos la diferencia a segundos
      let seconds = Math.floor(diff / 1000);
      // Calculamos las horas, minutos y segundos
      let hours = Math.floor(seconds / 3600);
      seconds %= 3600;
      let minutes = Math.floor(seconds / 60);
      seconds %= 60;
      // Formateamos el tiempo final
      let finalTime = str_pad_left(hours, '0', 2) + ':' + str_pad_left(minutes, '0', 2) + ':' + str_pad_left(seconds, '0', 2);

      return finalTime;
    },

    async getOrdenes(intSucursal) {
      try {
        if (intSucursal > 0) {

          let orden = await this.ordenFunctions.dataOrdenes(intSucursal);

          console.log("Órdenes de esta cocina:", orden);

          let id = 0;
          console.log(orden);
          console.log(this.config_38_valor);

          // Ordenar las órdenes por intOrden
          orden.sort((a, b) => a.intOrden - b.intOrden);

          const ordenesTemp = [];

          for (let order of orden) {
            if (order.intFinalizadoCocina == 1) {
              continue;
            }
            let node = {
              key: id.toString(),
              intPOSTipoServicio: order.intPOSTipoServicio,
              intEmpresa: order.intEmpresa,
              intSucursal: order.intSucursal,
              intPOSEnc: order.intPOSEnc,
              intOrden: order.intOrden,
              datFechaInicio: order.datFechaInicio,
              strPOSTipoServicio: order.strPOSTipoServicio,
              strTipoVenta: order.strTipoVenta,
              strCliente: order.strCliente,
              strCancelacionDevolucion: order.strCancelacionDevolucion,
              EstatusEnc: order.EstatusEnc,
              EstatusE: order.EstatusE,
              intCancelacionDevolucion: order.intCancelacionDevolucion,
              intFinalizado: order.intFinalizado,
              strNota: order.strNota,
              lapsoTiempo: "",
              color: "",
              posdet: [],
            };

            let detalle = await this.ordenFunctions.retrieve_idDet(
              order.intPOSEnc,
              intSucursal,
              order.intEmpresa
            );
            let idDet = 0;

            if (this.config_38_activo)
            {
              for (let det of detalle.posDet) {
                if (
                  this.config_38_valor
                    .split(',')
                    .some(x => x.trim().toLowerCase() === det.strFamilia.trim().toLowerCase())
                ) {
                  continue;
                }
                let detNodo = {
                  key: id.toString() + "-" + idDet.toString(),
                  intPOSEnc: det.intPOSEnc,
                  intPOSDet: det.intPOSDet,
                  intFolio: det.intFolio,
                  dblCantidad: det.dblCantidad,
                  strNombre: det.strNombre,
                  strFamilia: det.strFamilia,
                  intCancelacionDevolucion: det.intCancelacionDevolucion,
                  strComentarioCancelacion: det.strComentarioCancelacion,
                  posdetdet: [],
                };

                let idGrandChildren = 0;
                for (let detdet of det.posDetArticuloConfiguracion) {
                  let detdetNodo = {
                    key:
                      id.toString() +
                      "-" +
                      idDet.toString() +
                      "-" +
                      idGrandChildren.toString(),
                    strArticulo: detdet.strNombre,
                    cantidad: detdet.dblCantidad,
                  };
                  detNodo.posdetdet.push(detdetNodo);
                  idGrandChildren++;
                }

                node.posdet.push(detNodo);
                idDet++;
              }
            }
            else
            {
              for (let det of detalle.posDet) {
                if (det.strFamilia === "BEBIDAS") {
                  continue;
                }
                let detNodo = {
                  key: id.toString() + "-" + idDet.toString(),
                  intPOSEnc: det.intPOSEnc,
                  intPOSDet: det.intPOSDet,
                  intFolio: det.intFolio,
                  dblCantidad: det.dblCantidad,
                  strNombre: det.strNombre,
                  strFamilia: det.strFamilia,
                  intCancelacionDevolucion: det.intCancelacionDevolucion,
                  strComentarioCancelacion: det.strComentarioCancelacion,
                  posdetdet: [],
                };

                let idGrandChildren = 0;
                for (let detdet of det.posDetArticuloConfiguracion) {
                  let detdetNodo = {
                    key:
                      id.toString() +
                      "-" +
                      idDet.toString() +
                      "-" +
                      idGrandChildren.toString(),
                    strArticulo: detdet.strNombre,
                    cantidad: detdet.dblCantidad,
                  };
                  detNodo.posdetdet.push(detdetNodo);
                  idGrandChildren++;
                }

                node.posdet.push(detNodo);
                idDet++;
              }
            }

            if (node.posdet.length > 0) {
              ordenesTemp.push(node);
            }

            id++;
          }

          this.ordenes = ordenesTemp.sort((a, b) => a.intOrden - b.intOrden);

          // Inicializar lapsoTiempo y color al momento de cargar
          this.ordenes.forEach((orden) => {
            orden.fechaInicioMoment = moment(orden.datFechaInicio);
            orden.lapsoTiempo = this.getTime(orden);

            let segundosTotales = moment().diff(orden.fechaInicioMoment, "seconds");
            let hours = Math.floor(segundosTotales / 3600);
            segundosTotales = segundosTotales - hours * 3600;
            let minutes = Math.floor(segundosTotales / 60);
            if (minutes + hours * 60 >= 5) orden.color = "#ffffcc";
            if (minutes + hours * 60 >= 10) orden.color = "#ff9999";
          });
        }
      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        // loading.close();
      }
    },

    seleccionarOrden(index) {
      this.ordenSeleccionada = index;
    },

    deseleccionarOrden() {
      this.ordenSeleccionada = null;
    },

    async finalizar(orden, index) {
      try {
        await this.ordenFunctions.finalizarOrden(
          orden.intPOSEnc,
          orden.intSucursal,
          "COCINA"
        );

        this.ordenes.splice(index, 1);
        this.ordenSeleccionada = null;

      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      }
    },
  }
};
</script>


<style>
.ordenes-row {
  margin: 0 !important;
}

.orden-col {
  padding: 0 !important;
  margin: 0 !important;
}
.orden-seleccionada {
  border: 4px solid #1565C0 !important;
  box-shadow: 0 0 12px rgba(21, 101, 192, 0.7) !important;
  transform: scale(0.98);
  transition: all 0.15s ease;
}
.h5{
  color:red;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0
}

.cocina-header {
  padding: 0 16px;
}

.titulo-cocina {
  font-size: 20px;
  font-weight: 600;
}

.bloqueo-control {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: 24px;
  white-space: nowrap;
}

.bloqueo-control .v-input {
  margin-top: 0;
}
</style>